import React, { forwardRef, useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import "plyr-react/plyr.css";
import "./player-custom-styles.css";
import { usePlyr } from "plyr-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setModalOpen } from "../Redux/Slice/loginModalSlice";
import { getAnalytics, logEvent } from "firebase/analytics";
import ReactHlsPlayer from "react-hls-player";

import { BASE_URL, access_token, auth_token } from "../services/config";
import axios from "axios";
import { setShowStreamInfo } from "../Redux/Slice/streamlimitSlice";
import { setAuth } from "../Redux/Slice/authSlice";
import { setAccountData } from "../Redux/Slice/accountsDataSlice";
import LiveStream from "../pages/Videoplayer/LiveStream";
import { setIsrelatedVideosClicked } from "../Redux/Slice/videodetailSlice";
const videoOptions = null;
const useHls = (src, options, thumbnailSeekbarUrl) => {
  const hls = useRef(new Hls());
  const hasQuality = useRef(false);
  const [plyrOptions, setPlyrOptions] = useState(options);
  let defaultQuality = 0;
  const { category } = useParams();

  useEffect(() => {
    hasQuality.current = false;
  }, [options]);

  useEffect(() => {
    const controls = [
      "play-large",
      "rewind",
      "play",
      "fast-forward",
      "progress",
      `${category !== "live" ? "current-time" : ""}`,
      "mute",
      "volume",
      "captions",
      "settings",
      "pip",
      "airplay",
      "fullscreen",
    ];

    if (Hls.isSupported()) {
      if (src.videoUrl !== "") {
        // checked this condition due to trim related issue coming, sometimes src null or undefined
        hls.current.loadSource(src?.videoUrl);
        hls.current.attachMedia(document.querySelector(".plyr-react"));
        hls.current.on(Hls.Events.MANIFEST_PARSED, () => {
          if (hasQuality.current) return;

          const levels = hls.current.levels;
          const qualityOptions = levels.map((level) => level.height);
          qualityOptions.sort((a, b) => b - a);
          qualityOptions.unshift(defaultQuality);

          const quality = {
            default: defaultQuality,
            options: qualityOptions,
            forced: true,
            onChange: async (newQuality) => {
              if (newQuality === defaultQuality) {
                hls.current.startLoad();
                await hls.current.startLoad(-1);
                hls.current.currentLevel = -1;
              } else {
                levels.forEach((level, levelIndex) => {
                  if (level.height === newQuality) {
                    hls.current.currentLevel = levelIndex;
                  }
                });
              }
            },
          };

          const i18n = {
            qualityLabel: {
              0: "Auto",
            },
          };

          setPlyrOptions((prevOptions) => ({
            ...prevOptions,
            quality,
            i18n,
            autoplay: true,
            controls,
            // debug: true,
            clickToPlay: false,
            keyboard: {
              global: true,
            },
            previewThumbnails: {
              enabled: src.thumbnailUrl ? true : false,
              src: src.thumbnailUrl ? src.thumbnailUrl : "",
            },
          }));

          hasQuality.current = true;
        });
      }
    } else {
      setPlyrOptions((prevOptions) => ({
        ...prevOptions,
        controls,
        keyboard: {
          global: true,
        },
        clickToPlay: false,
      }));
    }
  }, [src, plyrOptions, category, thumbnailSeekbarUrl]);

  return { options: plyrOptions };
};

const CustomPlyrInstance = forwardRef((props, ref) => {
  const { source, videoDetails, options = null, thumbnailSeekbarUrl } = props;
  const regionsData = useSelector((state) => state.region.regionsData);
  const pausedRef = useRef(false);
  const navigation = useNavigate();
  const location = useLocation();
  const [seek, setSeek] = useState(0);
  const [startTime, setStartTime] = useState(0);
  const [selectedQuality, setSelectedQuality] = useState(0);
  const slidingTimeout = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();
  const [count, setCount] = useState(0);
  const resetTimer = useRef(null);
  const [isSeeking, setIsSeeking] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showThumbnailSeekBar, setShowThumbnailSeekBar] = useState(false);
  const videoRef = useRef(null);
  const [isForwarding, setIsForwarding] = useState(false);

  const [watchedDuration, setWatchedDuration] = useState(0);
  const [interactingWithControls, setInteractingWithControls] = useState(false);

  const [currentVideo, setCurrentVideo] = useState({
    source: source,
    details: videoDetails,
  });

  const { sessionId } = useSelector((state) => state.auth);
  const session_id = localStorage.getItem("session_id")
    ? localStorage.getItem("session_id")
    : sessionId;

  // console.log("videoDetails", videoDetails);
  const [progress, setProgress] = useState({ currentTime: 0, duration: 0 });
  const [videoEnded, setVideoEnded] = useState(false);
  const [nextVideo, setNextVideo] = useState({ source: null, details: null });
  const [showNextButton, setShowNextButton] = useState(false);
  const [watchHistoryError, setWatchHistoryError] = useState("");

  const [loginModalOpened, setLoginModalOpened] = useState(false);
  const [nextVideoDetails, setNextVideoDetails] = useState({});
  const [isUpNextAppear, setIsUpNextAppear] = useState(false);
  const [isNextContent, setIsNextContent] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(source?.login_status);
  const [isSubscribed, setIsSubscribed] = useState(source?.is_subscribed);
  const [isUpgraded, setIsUpgraded] = useState(
    source?.stream_info?.upgrade_plan
  );
  const [currentPlayedTime, setCurrentPlayedTime] = useState(0);
  const [isTrailer, setIsTrailer] = useState(
    source?.stream_info?.adaptive_url !== "" ? false : true
  );
  const [videoSource, setVideoSource] = useState({
    videoUrl: "",
    thumbnailUrl: "",
  });
  const [videoTitle, setVideoTitle] = useState("");
  const [paused, setPaused] = useState(false);
  const firebaseAnalytics = getAnalytics();
  const { traynamedata } = useSelector((state) => state.navmenu_called);

  const countRef = useRef(count);
  const watchedDurationRef = useRef(0);
  const relatedVideoClickedRef = useRef(false);

  // console.log("traynamedatasds", traynamedata.display_title)

  useEffect(() => {
    if (currentVideo.source?.stream_info?.adaptive_url !== "") {
      setVideoSource({
        videoUrl: currentVideo.source?.stream_info?.adaptive_url,
        thumbnailUrl: currentVideo.source?.stream_info?.seekbar_thumbnail_url,
      });
      setIsTrailer(false);
    } else {
      setVideoSource({
        videoUrl: currentVideo.source?.stream_info?.preview?.adaptive_url,
        thumbnailUrl: currentVideo.source?.stream_info?.seekbar_thumbnail_url,
      });
      setIsTrailer(true);
    }
    createVideoTitle();

    const playbackTimeInMilliseconds = convertTimeToMilliseconds(
      currentVideo.source?.stream_info?.play_back_time
    );
    setCurrentPlayedTime(playbackTimeInMilliseconds);
  }, [source, videoDetails, currentVideo]);

  const raptorRef = usePlyr(ref, {
    ...useHls(videoSource, options),
    speed: { selected: "Normal" },
  });

  useEffect(() => {
    if (!Hls.isSupported()) {
      const supportHLS = Boolean(
        raptorRef.current.canPlayType("application/vnd.apple.mpegurl")
      );
      if (supportHLS) {
        raptorRef.current.src = videoSource.videoUrl;
      }
    }
  }, [videoSource]);

  const userConfig = useSelector((state) => state.user_config.userConfigData);
  const watchhistoryIntervalTime =
    userConfig?.params_hash2?.config_params?.watchhistory_interval_sec;
  const historyAPI = userConfig?.params_hash2?.config_params?.watchhistory_api;
  const playBackStatusRef = useRef("playing");

  const progressRef = useRef(progress);
  useEffect(() => {
    progressRef.current = progress;
  }, [progress]);

  const triggeredEvent = useRef({
    pbStart: false,
    pbEnd: false,
  });

  const triggeredPercentages = useRef({
    percent10: false,
    percent25: false,
    percent50: false,
    percent75: false,
    percent90: false,
  });
  const sourcetab = localStorage.getItem("selectedMenuItem");

  const { layoutname } = useSelector((state) => state.shows);
  const { getallDetails } = useSelector((state) => state.getalldata || {});
  const { videodetailsitems } = useSelector((state) => state.video_details);
  const { navitemname } = useSelector((state) => state.navmenu_called);
  //  console.log("getallDetailsdsds", getallDetails)
  //  getallDetails?.user_info?.analytics_user_id
  const triggeranalytics = async (name, sec, event_id) => {
    const sessionId = session_id || "NA";
    const ip = regionsData?.ip || "NA";
    const state = regionsData?.state || "NA";
    const city = regionsData?.city_name || "NA";
    const postalCode = regionsData?.postal_code || "NA";
    const country = regionsData?.country_name;
    const guestuserid = `Guest${Math.floor(2e4 * Math.random())}`;

    // console.log(source);
    const obj = {
      content_provider: videoDetails?.content_provider || "NA",
      consumption_type: "online",
      content_type: videoDetails?.media_type || "NA",
      content_value: videoDetails?.content_value || "NA",
      device_id: "NA",
      genre: videoDetails?.display_genres.join(",") || "NA",
      quality: selectedQuality === 0 ? "Auto" : `${selectedQuality}p` || "Auto",
      source: navitemname?.display_title?.toLowerCase(),
      show_name: videoDetails?.show_name || "NA",
      show_id: videoDetails?.show_theme_id || "NA",
      series_name: videoDetails?.subcategory_name || "NA",
      series_id: videoDetails?.subcategory_id || "NA",
      session_id: sessionId || "NA",
      ip: ip || "NA",
      tray_id: videodetailsitems?.content_id,
      state: state || "NA",
      city: city || "NA",
      postal_code: postalCode || "NA",
      country: country,
      tray_name: traynamedata?.display_title?.toLowerCase(),
      u_id:
        getallDetails?.login_status === true
          ? getallDetails?.user_info?.analytics_user_id
          : guestuserid,
      value: sec,
      video_id: videoDetails?.content_id || "NA",
      video_name: videoDetails?.title || "NA",
      video_language: videoDetails?.language || "NA",
      subtitles: "NA",
      event_id: event_id,
    };
    // console.log("obj: ", obj);

    if (window && window.sdk && window.sdk.trackEvent) {
      window.sdk.trackEvent(name, obj);
    } else {
      console.error("Analytics SDK is not initialized yet.");
    }
  };

  const handleUnmount = () => {
    if (countRef.current > 0 && !triggeredEvent.current.pbEnd) {
      triggeranalytics("pb_end", countRef.current, 2);
      triggeredEvent.current.pbStart = false;
      triggeredEvent.current.pbEnd = true;
    }
  };

  useEffect(() => {
    return () => {
      if (!isNextContent) {
        handleUnmount();
      }
    };
  }, [isNextContent]);

  useEffect(() => {
    const handleCloseTab = (event) => {
      event.preventDefault();
      if (countRef.current > 0 && !triggeredEvent.current.pbEnd) {
        triggeranalytics("pb_end", countRef.current, 2);
        setCount(0);
        countRef.current = 0;
        setPaused(true);
        triggeredEvent.current.pbStart = false;
        triggeredEvent.current.pbEnd = true;
      }
    };

    if (!isNextContent) {
      window.addEventListener("beforeunload", handleCloseTab);
    }

    return () => {
      if (!isNextContent) {
        window.removeEventListener("beforeunload", handleCloseTab);
      }
    };
  }, [isNextContent]);

  // console.log("getalldetailsss", videodetailsitems);
  const isrelatedVideosClicked = useSelector(
    (state) => state.video_details.isrelatedVideosClicked
  );
  const previousVideoCountRef = useRef(0);

  useEffect(() => {
    // console.log("isrelatedVideosClickedss", isrelatedVideosClicked)

    let countInterval;

    const handleVideoPlayback = () => {
      if (!paused && !isForwarding && !isSeeking && !loading) {
        countInterval = setInterval(() => {
          setCount((prevCount) => {
            const newCount = prevCount + 1;
            countRef.current = newCount;
            return newCount;
          });
          setWatchedDuration((prevDuration) => {
            const newDuration = prevDuration + 1;
            watchedDurationRef.current = newDuration;
            return newDuration;
          });
        }, 1000);
      } else {
        clearInterval(countInterval);
      }
    };

    // if (isrelatedVideosClicked === true) {
    //   triggeranalytics("pb_end", countRef.current, 2);
    // }

    handleVideoPlayback();

    return () => clearInterval(countInterval);
  }, [paused, isForwarding, isSeeking, loading, videoEnded]);

  useEffect(() => {
    if (isrelatedVideosClicked === true) {
      // Update previousVideoCountRef to the current video's count
      previousVideoCountRef.current = countRef.current;
      // Trigger pb_end for the previous video using previousVideoCountRef
      triggeranalytics("pb_end", previousVideoCountRef.current, 2);
      // Reset the current video's count
      setCount(0);
      countRef.current = 0; // Ensure the ref is reset as well

      // Reset the flag in the redux store
      dispatch(setIsrelatedVideosClicked({ isrelatedVideosClicked: false }));
      triggeredEvent.current.pbStart = false;
      triggeredEvent.current.pbEnd = true;
    }
  }, [isrelatedVideosClicked]);

  // console.log("isforward", isForwarding)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isSeeking) {
        if (paused && count > 0 && !triggeredEvent.current.pbEnd) {
          triggeranalytics("pb_end", count, 2);
          setCount(0);
          triggeredEvent.current.pbStart = false;
          triggeredEvent.current.pbEnd = true;
        } else if (!triggeredEvent.current.pbStart) {
          triggeranalytics("pb_start", 1, 1);
          setPaused(false);
          triggeredEvent.current.pbStart = true;
          triggeredEvent.current.pbEnd = false;
        }
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [paused, isSeeking, videoEnded]);

  const nextItemUrl = `${BASE_URL}catalogs/${currentVideo.details?.catalog_id}/items/${currentVideo.details?.content_id}/next_item?auth_token=${auth_token}&access_token=${access_token}&region=${regionsData?.country_code2}&item_language=eng`;

  const loadWatchHistory = async () => {
    const currentTime = progressRef?.current?.currentTime;
    // console.log("currentTime", currentTime);
    try {
      var playBackTime = "00:00:00";
      if (currentTime) {
        var formattedTime = new Date(currentTime * 1000)
          .toISOString()
          .substr(11, 8);
        playBackTime = formattedTime;
      }
      if (currentTime > 0 && playBackTime !== "00:00:00") {
        const watchHistoryAPI = `${historyAPI}users/${session_id}/playlists/watchhistory`;

        if (isLoggedIn && !isTrailer) {
          //  const response =
          await axios.post(watchHistoryAPI, {
            auth_token: auth_token,
            access_token: access_token,
            listitem: {
              content_id: currentVideo?.details?.content_id,
              catalog_id: currentVideo?.details?.catalog_id,
              play_back_time: playBackTime,
              play_back_status: playBackStatusRef.current,
            },
          });
          // console.log("watchhistorydata", response.data);
        }
      }
    } catch (error) {
      setWatchHistoryError(error?.response?.data?.error?.message);
      console.log("waa errorsss", error?.response?.data?.error?.message);
    }
  };

  useEffect(() => {
    const updateHistoryIntervalId = setInterval(() => {
      if (!paused) {
        playBackStatusRef.current = "playing";
        loadWatchHistory();
      }
    }, watchhistoryIntervalTime * 1000);

    if (paused) {
      playBackStatusRef.current = "stopped";
    } else {
      playBackStatusRef.current = "playing";
    }

    return () => {
      clearInterval(updateHistoryIntervalId);
    };
  }, [paused, watchhistoryIntervalTime]);

  useEffect(() => {
    if (paused) {
      // console.log("stopped");
      playBackStatusRef.current = "stopped";
      loadWatchHistory();
    } else {
      // console.log("playing");
      playBackStatusRef.current = "playing";
      loadWatchHistory();
    }
  }, [paused]);

  useEffect(() => {
    if (watchHistoryError === "Invalid Session Id") {
      localStorage.removeItem("session_id");
      localStorage.setItem("login_status", false);
      localStorage.setItem("showSubscripeButton", true);
      dispatch(setAccountData({ accountData: {} }));
      dispatch(setAuth({ isLoggedIn: false, usersessionID: "" }));
      navigation("/home");
      dispatch(setShowStreamInfo({ showStreamLimit: true }));
      // window.location.href='/home'
    }
  }, [watchHistoryError]);

  const { accountData } = useSelector((state) => state.account_data);

  useEffect(() => {
    const fetchNextItem = async () => {
      try {
        const response = await axios.get(nextItemUrl);
        if (response.status === 200) {
          setNextVideoDetails(response?.data?.data);
          setNextVideo({ source: null, details: response.data.data });
          setIsUpNextAppear(true);
        }
      } catch (error) {
        setIsUpNextAppear(false);
        console.log(error);
      }
    };
    fetchNextItem();
  }, [currentVideo]);

  const createVideoTitle = () => {
    if (currentVideo.details?.media_type === "movie") {
      if (isTrailer) {
        setVideoTitle(`${currentVideo.details?.title} - Trailer`);
      } else {
        setVideoTitle(currentVideo.details?.title);
      }
    } else {
      if (isTrailer) {
        if (currentVideo.details?.show_name) {
          setVideoTitle(
            `${currentVideo.details?.show_name} - ${currentVideo.details?.title} - Trailer`
          );
        } else {
          setVideoTitle(`${currentVideo.details?.title} - Trailer`);
        }
      } else {
        if (currentVideo.details?.show_name) {
          setVideoTitle(
            `${currentVideo.details?.show_name} - ${currentVideo.details?.title}`
          );
        } else {
          setVideoTitle(`${currentVideo.details?.title}`);
        }
      }
    }
  };

  const convertTimeToMilliseconds = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    const totalMilliseconds = (hours * 3600 + minutes * 60 + seconds) * 1000;

    return totalMilliseconds;
  };

  useEffect(() => {
    const checkLoginStatus = () => {
      setIsLoggedIn(source?.login_status);
    };
    const checkSubscription = () => {
      setIsSubscribed(source?.is_subscribed);
    };
    const checkUpgradeStatus = () => {
      setIsUpgraded(source?.stream_info?.upgrade_plan);
    };
    checkLoginStatus();
    checkSubscription();
    checkUpgradeStatus();
  }, [isLoggedIn, isSubscribed, isUpgraded]);

  function useDebounce(callback, delay) {
    const timeoutRef = useRef(null);

    function debouncedCallback(...args) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }

    return debouncedCallback;
  }

  useEffect(() => {
    const plyrSource = ref?.current?.plyr;
    // console.log("plyrSource", plyrSource);
    const plyrInstance = ref?.current?.plyr?.elements?.buttons;
    const forwardButton = plyrInstance?.fastForward;
    const rewindButton = plyrInstance?.rewind;
    const playButton = plyrInstance?.play[0];
    const plyrContainer = ref?.current?.plyr?.elements?.container;
    if (selectedQuality !== plyrSource?.config?.quality?.selected) {
      setSelectedQuality(plyrSource?.config?.quality?.selected);
    }
    const skipIntroButtonStartTime = timeStringToSeconds(
      videoDetails?.intro_start_time
    );
    const skipIntroButtonEndTime = timeStringToSeconds(
      videoDetails?.intro_end_time
    );
    const currentTimeInSeconds = Math.floor(plyrSource?.currentTime);
    const videoDuration = Math.floor(plyrSource?.duration);
    const upNextButtonTime = videoDuration - 10;

    const callLoadWatchHistory = () => {
      loadWatchHistory();
    };

    if (
      !plyrSource ||
      typeof plyrSource.on !== "function" ||
      typeof plyrSource.off !== "function"
    ) {
      return;
    }

    if (forwardButton) {
      forwardButton.addEventListener("click", () => {
        setIsForwarding(true);
        callLoadWatchHistory();
      });
    }

    if (rewindButton) {
      rewindButton.addEventListener("click", () => {
        setIsForwarding(true);
        callLoadWatchHistory();
      });
    }

    if (plyrContainer) {
      const titleElement = document.createElement("div");
      titleElement.className = "plyr_control--overlaid plyr__title";
      const titleHeader = document.createElement("h5");
      titleHeader.textContent = videoTitle;
      const rating = document.createElement("p");
      rating.classList = "content__rating";
      rating.textContent = `RATED ${currentVideo?.details?.cbfc_rating}`;
      const displayGenres = document.createElement("p");
      displayGenres.className = "title__genre";
      const genresString = currentVideo?.details?.display_genres.join(", ");
      displayGenres.textContent = genresString;
      titleElement.appendChild(titleHeader);
      if (currentVideo?.details?.cbfc_rating) {
        titleElement.appendChild(rating);
      }
      if (currentVideo?.details?.display_genres?.length > 0) {
        titleElement.appendChild(displayGenres);
      }

      const existingTitle = plyrContainer?.querySelector(".plyr__title");

      if (!existingTitle) {
        plyrContainer.insertBefore(titleElement, plyrContainer?.firstChild);
      }

      const preRollAd = document.createElement("ins");
      preRollAd.id = "pre-roll-ad";
      preRollAd.setAttribute("data-adspot-key", "5fgp9a0u");
      preRollAd.setAttribute("data-source", "stagingweb.etvwin.com");
      preRollAd.setAttribute("data-container-id", "pre-roll-ad-container");
      preRollAd.setAttribute("data-refresh-rate", "30");

      const preRollAdContainer = document.createElement("div");
      preRollAdContainer.id = "pre-roll-ad-container";

      const existingPreRollAd = plyrContainer?.querySelector(
        "#pre-roll-ad-container"
      );
      if (!existingPreRollAd) {
        plyrContainer?.appendChild(preRollAd);
        plyrContainer?.appendChild(preRollAdContainer);
      }

      const midRollAd = document.createElement("ins");
      midRollAd.id = "mid-roll-ad";
      midRollAd.setAttribute("data-adspot-key", "5fgp9a0u");
      midRollAd.setAttribute("data-source", "stagingweb.etvwin.com");
      midRollAd.setAttribute("data-container-id", "mid-roll-ad-container");
      midRollAd.setAttribute("data-ad-breakduration", "90");

      const midRollAdContainer = document.createElement("div");
      midRollAdContainer.id = "mid-roll-ad-container";

      const existingMidRollAd = plyrContainer?.querySelector(
        "#mid-roll-ad-container"
      );
      if (!existingMidRollAd) {
        plyrContainer?.appendChild(midRollAd);
        plyrContainer?.appendChild(midRollAdContainer);
      }

      const existingButton = plyrContainer?.querySelector(".next__button");
      if (
        showNextButton &&
        nextVideo.details &&
        nextVideo.source &&
        !isTrailer
      ) {
        const nextButton = document.createElement("button");
        nextButton.className =
          "plyr_control plyer__control--overlaid next__button";
        nextButton.setAttribute("data-type", "up-next");
        nextButton.style.visibility = "visible";
        nextButton.style.opacity = 1;
        nextButton.style.zIndex = 2;
        nextButton.textContent = "Up Next";
        if (!existingButton) {
          plyrContainer?.appendChild(nextButton);
        }
        nextButton.addEventListener("click", () => {
          navigation(nextVideo.details?.seo_url);
          window.location.reload();
          setCurrentVideo({
            source: nextVideo.source,
            details: nextVideo.details,
          });
        });
      } else if (!showNextButton && existingButton) {
        plyrContainer?.removeChild(existingButton);
      }

      if (
        videoDetails?.intro_start_time &&
        currentTimeInSeconds >= skipIntroButtonStartTime &&
        currentTimeInSeconds <= skipIntroButtonEndTime &&
        !isTrailer
      ) {
        const existingSkipButton = plyrContainer?.querySelector(
          ".skip-intro__button"
        );

        if (!existingSkipButton) {
          const skipIntroButton = document.createElement("button");
          skipIntroButton.style.position = "absolute";
          skipIntroButton.style.right = "10px";
          skipIntroButton.className =
            "plyr_control plyer__control--overlaid skip-intro__button";
          skipIntroButton.setAttribute("data-type", "skip-intro");
          skipIntroButton.style.visibility = "visible";
          skipIntroButton.style.opacity = 1;
          skipIntroButton.style.zIndex = 2;
          skipIntroButton.textContent = "Skip Intro";

          plyrContainer?.appendChild(skipIntroButton);

          skipIntroButton.addEventListener("click", () => {
            const introEndTimeInSeconds = timeStringToSeconds(
              videoDetails?.intro_end_time
            );
            if (isFinite(introEndTimeInSeconds)) {
              plyrSource.currentTime = introEndTimeInSeconds;
            }
          });
        }
      } else {
        const existingSkipButton = plyrContainer?.querySelector(
          ".skip-intro__button"
        );

        if (existingSkipButton) {
          plyrContainer?.removeChild(existingSkipButton);
        }
      }

      if (currentTimeInSeconds >= videoDetails.duration_string_sec - 10) {
        if (isUpNextAppear) {
          setIsNextContent(true);
        } else {
          setIsNextContent(false);
        }
        const existingUpNextButton =
          plyrContainer?.querySelector(".up-next__button");

        if (!existingUpNextButton && isUpNextAppear && !isTrailer) {
          const upNextButton = document.createElement("button");
          upNextButton.style.position = "absolute";
          upNextButton.style.right = "25px";
          upNextButton.style.bottom = "80px";
          upNextButton.className =
            "plyr_control plyer__control--overlaid up-next__button";
          upNextButton.setAttribute("data-type", "up-next");
          upNextButton.style.visibility = "visible";
          upNextButton.style.opacity = 1;
          upNextButton.style.zIndex = 2;
          upNextButton.textContent = "Up Next";

          plyrContainer.appendChild(upNextButton);

          upNextButton.addEventListener("click", () => {
            window.location.href = nextVideoDetails?.seo_url;
          });
        }

        if (isUpNextAppear && videoEnded && upNextButtonTime && !isTrailer) {
          window.location.href = nextVideoDetails?.seo_url;
        }
      } else {
        const existingUpNextButton =
          plyrContainer?.querySelector(".up-next__button");

        if (existingUpNextButton) {
          plyrContainer.removeChild(existingUpNextButton);
        } else {
          setIsNextContent(false);
        }
      }

      if (isTrailer && videoEnded) {
        const modalContainer = document.createElement("div");
        modalContainer.className = "plyr_control--overlaid custom__modal";
        modalContainer.setAttribute("show-modal", "show");
        const existingModal = plyrContainer?.querySelector(".custom__modal");
        if (!existingModal) {
          const modalContent = document.createElement("div");
          modalContent.className = "modal__content";

          const modalTitle = document.createElement("h6");
          modalTitle.className = "modal__title";
          if (isUpgraded && !isSubscribed) {
            modalTitle.textContent =
              "Please Upgrade your Account to Start Streaming";
          } else {
            modalTitle.textContent = "Subscribe to watch this content";
          }
          const buttonContainer = document.createElement("div");
          buttonContainer.className = "button__container";
          buttonContainer.setAttribute("is-loggedin", isLoggedIn);
          const LoginButton = document.createElement("button");
          LoginButton.className = "modal__button";
          LoginButton.setAttribute("data-type", "login");
          LoginButton.textContent = "Login";
          LoginButton.title = "Login";
          LoginButton.addEventListener("click", () => {
            dispatch(setModalOpen());
            setLoginModalOpened(true);
          });

          const SubsCribeButton = document.createElement("button");
          SubsCribeButton.className = "modal__button";
          SubsCribeButton.setAttribute("data-type", "subscribe");
          SubsCribeButton.textContent = "Subscribe";
          SubsCribeButton.title = "Subscribe";
          SubsCribeButton.addEventListener("click", () => {
            navigation("/Subscription");
          });

          const upgradeButton = document.createElement("button");
          upgradeButton.className = "modal__button";
          upgradeButton.setAttribute("data-type", "upgrade");
          upgradeButton.textContent = "Upgrade Now";
          upgradeButton.title = "Upgrade Now";
          upgradeButton.addEventListener("click", () => {
            navigation("/Subscription");
          });

          const pauseIcon = playButton?.querySelector(".pause__icon");

          if (!isLoggedIn && !isSubscribed) {
            buttonContainer.appendChild(LoginButton);
            buttonContainer.appendChild(SubsCribeButton);
            modalContent.appendChild(modalTitle);
            modalContent.appendChild(buttonContainer);
            modalContainer.appendChild(modalContent);
            if (pauseIcon) {
              pauseIcon.style.display = "none";
            }

            plyrContainer?.appendChild(modalContainer);
          } else if (isUpgraded && !isSubscribed) {
            buttonContainer.appendChild(upgradeButton);
            modalContent.appendChild(modalTitle);
            modalContent.appendChild(buttonContainer);
            modalContainer.appendChild(modalContent);
            if (pauseIcon) {
              pauseIcon.style.display = "none";
            }

            plyrContainer?.appendChild(modalContainer);
          } else {
            buttonContainer.appendChild(SubsCribeButton);
            modalContent.appendChild(modalTitle);
            modalContent.appendChild(buttonContainer);
            modalContainer.appendChild(modalContent);
            if (pauseIcon) {
              pauseIcon.style.display = "none";
            }

            plyrContainer?.appendChild(modalContainer);
          }
        }
      }
    } else {
      return;
    }

    const changeButtonIcon = () => {
      const customizeButton = (button, svgContent) => {
        if (button) {
          const existingButton = button.querySelector(".custom__controls");
          if (!existingButton) {
            button.innerHTML = svgContent;
            const controlsParent = button.closest(".plyr__controls");

            if (controlsParent) {
              controlsParent.parentNode.insertBefore(
                button,
                controlsParent.nextSibling
              );
              button?.classList.remove("plyr__controls__item");
              button?.classList.add("plyr__control--overlaid");
              button?.classList.add("custom__controls");
            }
          }
        }
      };

      if (playButton) {
        playButton?.classList.add("videoel");
        const pauseIcon = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "svg"
        );
        pauseIcon.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        pauseIcon.setAttribute("viewBox", "0 0 64 64");
        pauseIcon.setAttribute("stroke-width", "4");
        pauseIcon.setAttribute(
          "class",
          "duration-300 transform transition-all pause__icon"
        );
        pauseIcon.innerHTML =
          '<path d="M19.2 10.99h7.03v41.96H19.2zM35.06 10.99h7.03v41.96h-7.03z"></path>';
        const existingPause = playButton?.querySelector(".pause__icon");
        if (!existingPause) {
          playButton?.appendChild(pauseIcon);
        }
      }

      customizeButton(
        forwardButton,
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" stroke-width="4" class="duration-300 transform transition-all"><path d="M23.93 41.41V23a.09.09 0 00-.16-.07s-2.58 3.69-4.17 4.78" stroke-linecap="round"></path><rect x="29.19" y="22.52" width="11.41" height="18.89" rx="5.7"></rect><path stroke-linecap="round" d="M54.43 15.41l-2.6 8.64-8.64-2.61M51.86 23.94a21.91 21.91 0 10.91 13.25"></path></svg>'
      );

      customizeButton(
        rewindButton,
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" stroke-width="4" class="duration-300 transform transition-all"><path stroke-linecap="round" d="M9.57 15.41l2.6 8.64 8.64-2.61M26.93 41.41V23a.09.09 0 00-.16-.07s-2.58 3.69-4.17 4.78"></path><rect x="32.19" y="22.52" width="11.41" height="18.89" rx="5.7"></rect><path d="M12.14 23.94a21.91 21.91 0 11-.91 13.25" stroke-linecap="round"></path></svg>'
      );
    };
    changeButtonIcon();

    return () => {
      if (forwardButton) {
        forwardButton.removeEventListener("click", () => {
          callLoadWatchHistory();
          // setIsForwarding(false)
        });
      }
      if (rewindButton) {
        rewindButton.removeEventListener("click", () => {
          callLoadWatchHistory();
          // setIsForwarding(false)
        });
      }
    };
  }, [
    ref.current?.plyr,
    videoEnded,
    showNextButton,
    paused,
    ref.current?.plyr?.currentTime,
    nextVideoDetails,
  ]);

  // console.log("forwarddddd", isForwarding)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsForwarding(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [isForwarding]);

  function timeStringToSeconds(timeString) {
    if (!timeString) return 0;

    const [hours, minutes, seconds] = timeString.split(":").map(parseFloat);
    return hours * 3600 + minutes * 60 + seconds;
  }

  const handleKeyDown = (event) => {
    if (event.key === "c" || event.key === "C") {
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  };

  useEffect(() => {
    if (getallDetails?.stream_info?.play_back_time !== "") {
      var splittedtime = getallDetails?.stream_info?.play_back_time?.split(":");
      const timeInSec =
        parseInt(splittedtime[0]) * 3600 +
        parseInt(splittedtime[1]) * 60 +
        parseInt(splittedtime[2]);
      if (timeInSec > 0) {
        setStartTime(timeInSec);
      } else {
        setStartTime(0);
      }
    } else {
      setStartTime(0);
    }
  }, [getallDetails?.stream_info?.play_back_time]);

  // console.log("startTimess", startTime)
  // console.log("durationnn", progress.duration)

  useEffect(() => {
    const plyrSource = ref.current?.plyr;
    // console.log("plyrSource: ", plyrSource);
    if (plyrSource) {
      const videoElement = plyrSource?.elements?.container?.querySelector(
        "video.plyr-react.plyr"
      );

      const plyrContainer = plyrSource?.elements?.container;

      const handleProgress = (e, t) => {
        setProgress({
          currentTime: e?.srcElement?.currentTime,
          duration: e?.srcElement?.duration,
        });

        const timeToShowNextButton = e?.srcElement?.duration - 15;

        if (progress.currentTime > timeToShowNextButton) {
          setShowNextButton(true);
        } else {
          setShowNextButton(false);
        }
      };

      const handleVideoEnded = () => {
        setVideoEnded(true);
        setPaused(true);
        setStartTime(0);
        setWatchedDuration(0);
        triggeredPercentages.current.percent10 = false;
        triggeredPercentages.current.percent25 = false;
        triggeredPercentages.current.percent50 = false;
        triggeredPercentages.current.percent75 = false;
        triggeredPercentages.current.percent90 = false;
        if (
          nextVideo?.details !== null &&
          nextVideo?.source !== null &&
          !isTrailer
        ) {
          navigation(nextVideo?.details?.seo_url);
          window.location.reload();
          setCurrentVideo({
            source: nextVideo?.source,
            details: nextVideo?.details,
          });
        }
      };

      if (videoElement) {
        videoElement.addEventListener("loadedmetadata", () => {
          const currentTime = currentPlayedTime / 1000;
          videoElement.currentTime = currentTime;
        });

        // console.log("currentTimess",  currentVideo.source?.stream_info?.play_back_time)
        // console.log("videoElement",  videoElement)

        videoElement.addEventListener("ended", handleVideoEnded);
        videoElement.addEventListener("timeupdate", handleProgress);
        videoElement.addEventListener("pause", () => {
          setPaused(true);
          pausedRef.current = true;
        });

        videoElement.addEventListener("play", () => {
          pausedRef.current = false;
          setPaused(false);
        });

        videoElement.addEventListener("playing", () => {
          setLoading(false);
          setPaused(false);
        });

        videoElement.addEventListener("waiting", () => {
          setLoading(true);
        });

        videoElement.addEventListener("seeking", () => {
          setIsSeeking(true);
        });

        videoElement.addEventListener("seeked", () => {
          setIsSeeking(false);
        });

        document.addEventListener("keydown", handleKeyDown);

        return () => {
          videoElement.removeEventListener("ended", handleVideoEnded);
          videoElement.removeEventListener("timeupdate", handleProgress);
          document.removeEventListener("keydown", handleKeyDown);
          videoElement.removeEventListener("pause", () => {});
          videoElement.removeEventListener("play", () => {});
          videoElement.removeEventListener("seeking", () => {});
          videoElement.removeEventListener("seeked", () => {});
          videoElement.removeEventListener("playing", () => {});
          videoElement.removeEventListener("waiting", () => {});
          videoElement.removeEventListener("ready", () => {});
        };
      }
    }
  }, [ref.current?.plyr, videoEnded, paused]);

  const { category, seo_url } = useParams();

  useEffect(() => {
    if (category !== "live" && progress.duration > 0) {
      const duration = Math.floor(progress.duration - startTime);
      const percent10 = Math.floor(duration * 0.1);
      const percent25 = Math.floor(duration * 0.25);
      const percent50 = Math.floor(duration * 0.5);
      const percent75 = Math.floor(duration * 0.75);
      const percent90 = Math.floor(duration * 0.9);

      if (
        percent10 > 0 &&
        watchedDuration === percent10 &&
        !triggeredPercentages.current.percent10
      ) {
        console.log("percent10: ", percent10);
        triggeranalytics("pb_10", percent10, 16);
        triggeredPercentages.current.percent10 = true;
      } else if (
        percent25 > 0 &&
        watchedDuration === percent25 &&
        !triggeredPercentages.current.percent25
      ) {
        console.log("percent25: ", percent25);
        triggeranalytics("pb_25", percent25, 17);
        triggeredPercentages.current.percent25 = true;
      } else if (
        percent50 > 0 &&
        watchedDuration === percent50 &&
        !triggeredPercentages.current.percent50
      ) {
        console.log("percent50: ", percent50);
        triggeranalytics("pb_50", percent50, 18);
        triggeredPercentages.current.percent50 = true;
      } else if (
        percent75 > 0 &&
        watchedDuration === percent75 &&
        !triggeredPercentages.current.percent75
      ) {
        console.log("percent75: ", percent75);
        triggeranalytics("pb_75", percent75, 19);
        triggeredPercentages.current.percent75 = true;
      } else if (
        percent90 > 0 &&
        watchedDuration === percent90 &&
        !triggeredPercentages.current.percent90
      ) {
        console.log("percent90: ", percent90);
        triggeranalytics("pb_90", percent90, 20);
        triggeredPercentages.current.percent90 = true;
      }
    }
  }, [progress.duration, progress.currentTime, category, videoEnded]);

  // useEffect(() => {
  //   if (paused) {
  //     setPreviousWatchTime(prevTime => prevTime + progress.currentTime);
  //   }
  // }, [paused]);

  // console.log("getallDetails", getallDetails);
  function convertToSeconds(timeString) {
    if (!timeString) {
      return 0; // or handle the undefined case as needed
    }

    const timeParts = timeString.split(":");

    if (timeParts.length !== 3) {
      return 0; // or handle invalid time format as needed
    }

    const hours = parseInt(timeParts[0], 10) || 0;
    const minutes = parseInt(timeParts[1], 10) || 0;
    const seconds = parseInt(timeParts[2], 10) || 0;

    return hours * 3600 + minutes * 60 + seconds;
  }

  const WatchedTime = getallDetails?.stream_info?.play_back_time;
  const WatchedTimeInSeconds = convertToSeconds(WatchedTime);
  // console.log("getallDetailssdsd", WatchedTimeInSeconds);

  // console.log("videoSource", videoSource?.stream_info);

  const setupDoubleClickEventListeners = (button) => {
    const handleButtonDoubleClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    if (button) {
      button.addEventListener("dblclick", handleButtonDoubleClick);
      return () => {
        button.removeEventListener("dblclick", handleButtonDoubleClick);
      };
    }
  };

  const plyrSource = ref.current?.plyr;

  useEffect(() => {
    const forwardButton = plyrSource?.elements?.buttons?.fastForward;
    const rewindButton = plyrSource?.elements?.buttons?.rewind;
    const playButton = plyrSource?.elements?.buttons?.play[0];
    // const settings = plyrSource?.elements?.settings?.buttons?.speed;
    // console.log("settingssgg", settings);

    const cleanUpForwardButton = setupDoubleClickEventListeners(forwardButton);
    const cleanUpRewindButton = setupDoubleClickEventListeners(rewindButton);
    const cleanUpPlayButton = setupDoubleClickEventListeners(playButton);

    return () => {
      cleanUpForwardButton && cleanUpForwardButton();
      cleanUpRewindButton && cleanUpRewindButton();
      cleanUpPlayButton && cleanUpPlayButton();
    };
  }, [
    plyrSource?.elements?.buttons?.play,
    plyrSource?.elements?.buttons?.fastForward,
    plyrSource?.elements?.buttons?.rewind,
  ]);

  //   useEffect(() => {
  // console.log("videoUrl", currentVideo.source?.stream_info?.adaptive_url)
  //     if (!currentVideo.source?.stream_info?.adaptive_url) {
  //       raptorRef.current.disablePictureInPicture = true;
  //     }
  //   }, [category]);

  const handleClosePip = () => {
    console.log("pictureInPictureElement", document.pictureInPictureElement);
    if (document.pictureInPictureElement) {
      document.exitPictureInPicture().catch((error) => {
        console.error("Failed to exit Picture-in-Picture mode:", error);
      });
    }
  };

  // useEffect(() => {
  //   handleClosePip()
  // }, [location.pathname])
  // useEffect(() => {
  //   if (thumbnailSeekbarUrl) {
  //     const player = raptorRef.current.plyr;

  return (
    <>
      {/* <p>Count: {count}</p> */}
      <video ref={raptorRef} className="plyr-react plyr" />

      {/* <button onClick={handleClosePip}>Close PiP</button> */}
    </>
  );
});

const CustomVideoPlayer = ({ videoSource }) => {
  const playerRef = useRef(null);

  // console.log("videoSource", videoSource);
  const { videodetailsitems } = useSelector((state) => state.video_details);
  const { accountData } = useSelector((state) => state.account_data);
  const sourcetab = localStorage.getItem("selectedMenuItem");

  const { layoutname } = useSelector((state) => state.shows);
  const { getallDetails } = useSelector((state) => state.getalldata || {});
  const userConfig = useSelector((state) => state.user_config.userConfigData);
  const { sessionId } = useSelector((state) => state.auth);
  const session_id = localStorage.getItem("session_id")
    ? localStorage.getItem("session_id")
    : sessionId;
  const regionsData = useSelector((state) => state.region.regionsData);
  const { category, seo_url } = useParams();

  const userAgent = navigator.userAgent;

  const isIOS = /iPhone|iPod/.test(navigator.userAgent);

  // useEffect(() => {
  //   const iOSVersion = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/) ? userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/).slice(1).join('.') : null;
  //   if(isIOS === true){
  //     alert("isIOS", isIOS)
  //     alert(`iOS version: ${iOSVersion}`);
  //   }
  // }, [])
  const videoRef = useRef(null);
  const [paused, setPaused] = useState(false);
  const [count, setCount] = useState(0);
  const countRef = useRef(0); // A ref to keep track of count changes without causing re-renders
  const [watchedDuration, setWatchedDuration] = useState(0);
  const [isForwarding, setIsForwarding] = useState(false);
  const [progress, setProgress] = useState({ currentTime: 0, duration: 0 });
  const [startTime, setStartTime] = useState(0);
  const [showNextButton, setShowNextButton] = useState(false);
  const [videoEnded, setVideoEnded] = useState(false);
  const { navitemname } = useSelector((state) => state.navmenu_called);
  const { traynamedata } = useSelector((state) => state.navmenu_called);
  const guestuserid = `Guest${Math.floor(2e4 * Math.random())}`;

  const triggeranalytics = async (name, sec, event_id) => {
    const sessionId = session_id || "NA";
    const user_id = accountData?.user_id;
    const ip = regionsData?.ip || "NA";
    const state = regionsData?.state || "NA";
    const city = regionsData?.city_name || "NA";
    const postalCode = regionsData?.postal_code || "NA";
    const country = regionsData?.country_name;
    const obj = {
      content_provider: videodetailsitems?.content_provider || "NA",
      consumption_type: "online",
      content_type: videodetailsitems?.media_type || "NA",
      content_value: videodetailsitems?.content_value || "NA",
      device_id: "NA",
      genre: videodetailsitems?.display_genres.join(",") || "NA",
      quality: "Auto",
      source: navitemname?.display_title?.toLowerCase(),
      show_name: videodetailsitems?.show_name || "NA",
      show_id: videodetailsitems?.show_theme_id || "NA",
      series_name: videodetailsitems?.subcategory_name || "NA",
      series_id: videodetailsitems?.subcategory_id || "NA",
      session_id: sessionId || "NA",
      ip: ip || "NA",
      tray_id: videodetailsitems?.content_id,
      state: state || "NA",
      city: city || "NA",
      postal_code: postalCode || "NA",
      country: country,
      tray_name: traynamedata?.display_title?.toLowerCase(),
      u_id:
        getallDetails?.login_status === true
          ? getallDetails?.user_info?.analytics_user_id
          : guestuserid,
      value: sec,
      video_id: videodetailsitems?.content_id || "NA",
      video_name: videodetailsitems?.title || "NA",
      video_language: videodetailsitems?.language || "NA",
      subtitles: "NA",
      event_id: event_id,
    };

    if (window && window.sdk && window.sdk.trackEvent) {
      window.sdk.trackEvent(name, obj);
    } else {
      console.error("Analytics SDK is not initialized yet.");
    }
  };

  const handlePlay = () => {
    playerRef.current.play();
    setPaused(false);
    // console.log("Video played");
    // console.log("pauseeee", false);
    triggeranalytics("pb_start", 1, 1);
  };
  const handlePause = () => {
    playerRef.current.pause();
    setPaused(true);
    triggeranalytics("pb_end", count, 2);
    // console.log("Video paused")
    // console.log("pauseeee", true);
    setCount(0);
  };

  const handleVideoEnd = () => {
    playerRef.current.pause();
    setPaused(true);
    // triggeranalytics("pb_end", count, 2);
    console.log("Playback finished");
    console.log("Playback", true);
    setCount(0);
  };

  // useEffect(() => {
  //   if (paused && count > 0) {
  //     triggeranalytics("pb_end", count, 2);
  //     setCount(0);
  //   } else {
  //     triggeranalytics("pb_start", 1, 1);
  //   }
  // }, [paused]);

  // console.log("isForwaesdds", isForwarding)

  useEffect(() => {
    let countInterval;

    const handleVideoPlayback = () => {
      if (!paused) {
        countInterval = setInterval(() => {
          setCount((prevCount) => prevCount + 1);
          setWatchedDuration((prevDuration) => prevDuration + 1);
        }, 1000);
      } else {
        clearInterval(countInterval);
      }
    };

    handleVideoPlayback();

    return () => clearInterval(countInterval);
  }, [paused]);

  const handleProgress = (e) => {
    const currentTime = e.target.currentTime;
    const duration = e.target.duration;

    setProgress({ currentTime, duration });

    // console.log("Current Duration:", currentTime); // Log the current duration

    const timeToShowNextButton = duration - 15;

    if (currentTime > timeToShowNextButton) {
      setShowNextButton(true);
    } else {
      setShowNextButton(false);
    }
  };

  useEffect(() => {
    const videoElement = playerRef.current;

    if (videoElement) {
      videoElement.addEventListener("timeupdate", handleProgress);
      // videoElement.addEventListener("ended", handleVideoEnded);
      // videoElement.addEventListener("pause", handlePause);
      // videoElement.addEventListener("play", handlePlay);

      // document.addEventListener("keydown", handleKeyDown);

      return () => {
        videoElement.removeEventListener("timeupdate", handleProgress);
        // videoElement.removeEventListener("ended", handleVideoEnded);
        // videoElement.removeEventListener("pause", handlePause);
        // videoElement.removeEventListener("play", handlePlay);
        // document.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [playerRef.current, videoEnded]);

  const triggeredPercentages = useRef({
    percent10: false,
    percent25: false,
    percent50: false,
    percent75: false,
    percent90: false,
  });

  // console.log("dfdfdfdfd", progress.duration)

  useEffect(() => {
    if (category !== "live" && progress.duration > 0) {
      const duration = Math.floor(progress.duration - startTime);
      const percent10 = Math.floor(duration * 0.1);
      const percent25 = Math.floor(duration * 0.25);
      const percent50 = Math.floor(duration * 0.5);
      const percent75 = Math.floor(duration * 0.75);
      const percent90 = Math.floor(duration * 0.9);

      if (
        percent10 > 0 &&
        watchedDuration === percent10 &&
        !triggeredPercentages.current.percent10
      ) {
        // console.log("percenttennn", percent10)
        triggeranalytics("pb_10", percent10);
        triggeredPercentages.current.percent10 = true;
      } else if (
        percent25 > 0 &&
        watchedDuration === percent25 &&
        !triggeredPercentages.current.percent25
      ) {
        // console.log("percenttwentyyy", percent25)
        triggeranalytics("pb_25", percent25);
        triggeredPercentages.current.percent25 = true;
      } else if (
        percent50 > 0 &&
        watchedDuration === percent50 &&
        !triggeredPercentages.current.percent50
      ) {
        triggeranalytics("pb_50", percent50);
        triggeredPercentages.current.percent50 = true;
      } else if (
        percent75 > 0 &&
        watchedDuration === percent75 &&
        !triggeredPercentages.current.percent75
      ) {
        triggeranalytics("pb_75", percent75);
        triggeredPercentages.current.percent75 = true;
      } else if (
        percent90 > 0 &&
        watchedDuration === percent90 &&
        !triggeredPercentages.current.percent90
      ) {
        triggeranalytics("pb_90", percent90);
        triggeredPercentages.current.percent90 = true;
      }
    }
  }, [progress.duration, progress.currentTime, category]);

  useEffect(() => {
    if (getallDetails?.stream_info?.play_back_time !== "") {
      var splittedtime = getallDetails?.stream_info?.play_back_time?.split(":");
      const timeInSec =
        parseInt(splittedtime[0]) * 3600 +
        parseInt(splittedtime[1]) * 60 +
        parseInt(splittedtime[2]);
      if (timeInSec > 0) {
        setStartTime(timeInSec);
      } else {
        setStartTime(0);
      }
    } else {
      setStartTime(0);
    }
  }, [getallDetails?.stream_info?.play_back_time]);

  // console.log("playerRefsd", playerRef)

  return (
    <>
      {isIOS ? (
        <ReactHlsPlayer
          playerRef={playerRef}
          src={
            videoSource?.stream_info?.adaptive_url ||
            videoSource?.stream_info?.preview?.adaptive_url
          }
          autoPlay={true}
          controls={true}
          width="100%"
          height="auto"
          // quality={selectedQuality}
          config={{
            file: {
              attributes: {
                controlsList: "nodownload",
                crossOrigin: "anonymous",
                // quality: selectedQuality,
              },
            },
          }}
          onPlay={handlePlay}
          onPause={handlePause}
          // onEnded={handleVideoEnd}
        />
      ) : (
        <CustomPlyrInstance
          ref={videoRef}
          source={videoSource}
          options={videoOptions}
          videoDetails={videodetailsitems}
        />
      )}

      {category === "live" && seo_url === "etv-andhra-pradesh-1" ? (
        <div>
          <LiveStream videoSource={videoSource} />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default CustomVideoPlayer;
